
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  errorMessage,
  assignTagsRoute,
  enterpriseApplicationsKey,
  employerApplicationsKey,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { applicantDetailsKey } from '@features/applicant';

type useAssignTagsProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useAssignTags = ({
  setErrorText = () => { },
}: useAssignTagsProps) => {
  const client = useQueryClient();

  const { mutate: assignTags, isLoading: isAssignTagsLoading } =
    useMutation({
      mutationFn: (variables: {
        application_id: number[];
        tags: number[];
        company_id?: number | string;
      }) => {
        // Send the variables object as JSON
        return axiosInstance
          .post(assignTagsRoute, variables, {
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then((res) => res.data);
      },
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          client.invalidateQueries(enterpriseApplicationsKey);
          client.invalidateQueries(applicantDetailsKey);
          client.invalidateQueries(employerApplicationsKey);
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
    });

  return {
    assignTags,
    isAssignTagsLoading,
  };
};
